import * as actionType from "../userActionType";

const init = { newitem: { coordinates: [51.389666, 35.683625] } };

export const users = (state = init, { type, payload }) => {
  switch (type) {
    case actionType.LOGIN:
      return {
        ...state,
        ...payload,
      };

    case actionType.CLEAR_USER:
      return {};

    default:
      return state;
  }
};
